export const homepageHelmetProps = {
  title:
    "On Beauty Aesthetics - Produkte Premium për Kujdesin e Lëkurës | Premium Skincare Products",
  meta: [
    {
      name: "description",
      content:
        "Zbuloni produkte premium për kujdesin e lëkurës, duke përfshirë kremra, dyll, serume, locione, qumësht trupi dhe masazhe me vaj. Përmirësoni bukurinë tuaj me On Beauty Aesthetics. | Discover premium skincare products, including creams, waxes, serums, lotions, body milk, and massage oils. Enhance your beauty with On Beauty Aesthetics.",
    },
    {
      name: "keywords",
      content:
        "skincare, creams, wax, serums, lotions, body milk, massage oil, beauty products, premium aesthetics, skincare Kosovo, kujdes lëkure, kremra, dyll, serume, locione, qumësht trupi, vaj për masazh, produkte bukurie, estetika premium",
    },
    // Open Graph meta tags
    {
      property: "og:title",
      content:
        "On Beauty Aesthetics - Produkte Premium për Kujdesin e Lëkurës | Premium Skincare Products",
    },
    {
      property: "og:description",
      content:
        "Zbuloni produkte premium për kujdesin e lëkurës, duke përfshirë kremra, dyll, serume, locione, qumësht trupi dhe masazhe me vaj. Përmirësoni bukurinë tuaj me On Beauty Aesthetics. | Discover premium skincare products, including creams, waxes, serums, lotions, body milk, and massage oils. Enhance your beauty with On Beauty Aesthetics.",
    },
    {
      property: "og:type",
      content: "website",
    },
    {
      property: "og:url",
      content: "https://www.onbeautyaesthetics.com",
    },
    {
      property: "og:image",
      content: "https://www.onbeautyaesthetics.com/logo512.png",
    },
    {
      property: "og:image:alt",
      content: "On Beauty Aesthetics - Premium Skincare Products",
    },
    {
      property: "og:site_name",
      content: "On Beauty Aesthetics",
    },
    {
      property: "og:locale",
      content: "sq_AL",
    },
    {
      property: "og:locale:alternate",
      content: "en_US",
    },
    // Twitter Card meta tags
    {
      name: "twitter:card",
      content: "summary_large_image",
    },
    {
      name: "twitter:title",
      content:
        "On Beauty Aesthetics - Produkte Premium për Kujdesin e Lëkurës | Premium Skincare Products",
    },
    {
      name: "twitter:description",
      content:
        "Zbuloni produkte premium për kujdesin e lëkurës, duke përfshirë kremra, dyll, serume, locione, qumësht trupi dhe masazhe me vaj. Përmirësoni bukurinë tuaj me On Beauty Aesthetics.",
    },
    {
      name: "twitter:image",
      content: "https://www.onbeautyaesthetics.com/logo512.png",
    },
    {
      name: "twitter:image:alt",
      content: "On Beauty Aesthetics - Premium Skincare Products",
    },
  ],
  link: [
    { rel: "canonical", href: "https://www.onbeautyaesthetics.com" },
    {
      rel: "sitemap",
      type: "application/xml",
      href: "https://www.onbeautyaesthetics.com/sitemap.xml",
    },
  ],
};

export const aboutUsHelmetProps = {
  title: "Rreth Nesh - On Beauty Aesthetics | About Us - On Beauty Aesthetics",
  meta: [
    {
      name: "description",
      content:
        "Mësoni më shumë rreth On Beauty Aesthetics, burimi juaj i besueshëm për produkte premium për kujdesin e lëkurës. Ne jemi të specializuar në kremra, serume, locione dhe më shumë për të përmirësuar bukurinë tuaj. | Learn about On Beauty Aesthetics, your trusted source for premium skincare products. We specialize in creams, serums, lotions, and more to enhance your beauty. ",
    },
    {
      name: "keywords",
      content:
        "about us, skincare experts, premium beauty, creams, serums, lotions, body milk, massage oil, kujdes lëkure, ekspertë të bukurisë, produkte premium, kremra, serume, locione, qumësht trupi, vaj për masazh",
    },
  ],
  link: [
    { rel: "canonical", href: "https://www.onbeautyaesthetics.com/about-us" },
  ],
};

export const contactUsHelmetProps = {
  title:
    "Na Kontaktoni - On Beauty Aesthetics | Contact Us - On Beauty Aesthetics",
  meta: [
    {
      name: "description",
      content:
        "Na kontaktoni për pyetje rreth produkteve tona premium për kujdesin e lëkurës, duke përfshirë kremra, dyll, serume dhe më shumë. Jemi këtu për t'ju ndihmuar. | Contact On Beauty Aesthetics for inquiries about our premium skincare products, including creams, waxes, serums, and more. We're here to help.",
    },
    {
      name: "keywords",
      content:
        "contact us, skincare support, premium products, creams, serums, lotions, massage oil, na kontaktoni, produkte kujdesi lëkurë, produkte premium, kremra, serume, locione, vaj për masazh",
    },
  ],
  link: [
    { rel: "canonical", href: "https://www.onbeautyaesthetics.com/contact-us" },
  ],
};

export const shopHelmetProps = {
  title:
    "Dyqan për Produkte të Kujdesit të Lëkurës - On Beauty Aesthetics | Shop Skincare Products - On Beauty Aesthetics",
  meta: [
    {
      name: "description",
      content:
        "Shfletoni dyqanin tonë për produkte premium për kujdesin e lëkurës. Blini kremra, serume, locione, qumësht trupi dhe masazhe me vaj. Përmirësoni bukurinë tuaj me produktet tona cilësore. | Explore our shop for premium skincare products. Buy creams, serums, lotions, body milk, and massage oils. Enhance your beauty with our top-quality products.",
    },
    {
      name: "keywords",
      content:
        "shop skincare, creams, serums, lotions, body milk, massage oil, premium beauty, skincare Kosovo, dyqan kujdesi lëkure, kremra, serume, locione, qumësht trupi, vaj për masazh, produkte premium",
    },
    // Open Graph meta tags
    {
      property: "og:title",
      content:
        "Dyqan për Produkte të Kujdesit të Lëkurës - On Beauty Aesthetics | Shop Skincare Products",
    },
    {
      property: "og:description",
      content:
        "Shfletoni dyqanin tonë për produkte premium për kujdesin e lëkurës. Blini kremra, serume, locione, qumësht trupi dhe masazhe me vaj.",
    },
    {
      property: "og:type",
      content: "website",
    },
    {
      property: "og:url",
      content: "https://www.onbeautyaesthetics.com/shop",
    },
    {
      property: "og:image",
      content: "https://www.onbeautyaesthetics.com/logo512.png",
    },
    {
      property: "og:site_name",
      content: "On Beauty Aesthetics",
    },
    // Twitter Card meta tags
    {
      name: "twitter:card",
      content: "summary_large_image",
    },
    {
      name: "twitter:title",
      content:
        "Dyqan për Produkte të Kujdesit të Lëkurës - On Beauty Aesthetics",
    },
    {
      name: "twitter:description",
      content:
        "Shfletoni dyqanin tonë për produkte premium për kujdesin e lëkurës. Blini kremra, serume, locione, qumësht trupi dhe masazhe me vaj.",
    },
    {
      name: "twitter:image",
      content: "https://www.onbeautyaesthetics.com/logo512.png",
    },
  ],
  link: [{ rel: "canonical", href: "https://www.onbeautyaesthetics.com/shop" }],
};

export const singleProductHelmetProps = {
  title:
    "Produkt Premium për Kujdesin e Lëkurës - On Beauty Aesthetics | Premium Skincare Product - On Beauty Aesthetics ",
  meta: [
    {
      name: "description",
      content:
        "Zbuloni përfitimet e produkteve tona premium për kujdesin e lëkurës, duke përfshirë kremra, serume, locione, qumësht trupi dhe masazhe me vaj. Ideale për përmirësimin e bukurisë dhe relaksimit. | Discover the benefits of our premium skincare products, including creams, serums, lotions, body milk, and massage oils. Perfect for enhancing beauty and relaxation. ",
    },
    {
      name: "keywords",
      content:
        "skincare product, premium cream, serum, lotion, body milk, massage oil, beauty product, produkt kujdesi lëkure, krem premium, serum, locion, qumësht trupi, vaj për masazh, produkt bukurie",
    },
  ],
  link: [
    {
      rel: "canonical",
      href: "https://www.onbeautyaesthetics.com/product/unique-product-name",
    },
  ],
};

export const cartHelmetProps = {
  title: "Shporta - On Beauty Aesthetics | Cart - On Beauty Aesthetics",
  meta: [
    {
      name: "description",
      content:
        "Shporta juaj me produkte premium për kujdesin e lëkurës. Kryeni blerjen tuaj dhe porositni produktet tona cilësore për kujdesin e lëkurës. | Your cart with premium skincare products. Complete your purchase and order our high-quality skincare products.",
    },
    {
      name: "keywords",
      content:
        "cart, shopping cart, checkout, skincare products, creams, serums, lotions, body milk, massage oil, shporta, blerje, produkte kujdesi lëkure, kremra, serume, locione",
    },
  ],
  link: [
    {
      rel: "canonical",
      href: "https://www.onbeautyaesthetics.com/cart",
    },
  ],
};

export const thankyouHelmetProps = {
  title:
    "Faleminderit për Porosinë - On Beauty Aesthetics | Thank You - On Beauty Aesthetics",
  meta: [
    {
      name: "description",
      content:
        "Faleminderit për porosinë tuaj! Porosia juaj do të procesohet së shpejti dhe do të pranoni detajet në email. | Thank you for your order! Your order will be processed soon and you'll receive details via email.",
    },
    {
      name: "keywords",
      content:
        "thank you, order confirmation, purchase confirmation, faleminderit, konfirmim porosie",
    },
  ],
  link: [
    {
      rel: "canonical",
      href: "https://www.onbeautyaesthetics.com/thankyou",
    },
  ],
};

export const privacyHelmetProps = {
  title:
    "Politika e Privatësisë - On Beauty Aesthetics | Privacy Policy - On Beauty Aesthetics",
  meta: [
    {
      name: "description",
      content:
        "Lexoni politikën tonë të privatësisë për të mësuar se si mbledhim, përdorim dhe mbrojmë të dhënat tuaja. | Read our privacy policy to learn how we collect, use, and protect your data.",
    },
    {
      name: "keywords",
      content:
        "privacy policy, data protection, GDPR, privacy, politikë privatësisë, mbrojtje të dhënash",
    },
  ],
  link: [
    {
      rel: "canonical",
      href: "https://www.onbeautyaesthetics.com/privacy-policy",
    },
  ],
};

export const termsHelmetProps = {
  title:
    "Kushtet e Shërbimit - On Beauty Aesthetics | Terms of Service - On Beauty Aesthetics",
  meta: [
    {
      name: "description",
      content:
        "Lexoni kushtet tona të shërbimit për të kuptuar rregullat dhe kushtet e përdorimit të shërbimit tonë. | Read our terms of service to understand the rules and conditions for using our service.",
    },
    {
      name: "keywords",
      content:
        "terms of service, legal terms, service agreement, kushte shërbimi, kushte ligjore",
    },
  ],
  link: [
    {
      rel: "canonical",
      href: "https://www.onbeautyaesthetics.com/terms-of-service",
    },
  ],
};

export const shippingHelmetProps = {
  title:
    "Informacione për Transportin - On Beauty Aesthetics | Shipping Information - On Beauty Aesthetics",
  meta: [
    {
      name: "description",
      content:
        "Informacione për politikën tonë të transportit, kohët e dorëzimit dhe tarifat e transportit. | Information about our shipping policy, delivery times, and shipping fees.",
    },
    {
      name: "keywords",
      content:
        "shipping, delivery, shipping policy, transport, dorëzim, politikë transporti",
    },
  ],
  link: [
    {
      rel: "canonical",
      href: "https://www.onbeautyaesthetics.com/shipping",
    },
  ],
};

export const notFoundHelmetProps = {
  title:
    "Faqja nuk u Gjet - On Beauty Aesthetics | Page Not Found - On Beauty Aesthetics",
  meta: [
    {
      name: "description",
      content:
        "Faqja që po kërkoni nuk ekziston. Kthehuni në faqen kryesore ose shfletoni produktet tona. | The page you're looking for doesn't exist. Return to the homepage or browse our products.",
    },
  ],
  link: [
    {
      rel: "canonical",
      href: "https://www.onbeautyaesthetics.com/404",
    },
  ],
};
